<template>
    <GuestLayout>
        <Head :title="this.title" />
        <div class="text-center">
            <h1 class="text-2xl mb-2">{{ this.title }}</h1>
            <p class="pb-4">{{ this.description }}</p>
            <a v-show="this.status != 503" href="/" type="button" class="text-white bg-primary-500 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none">
                {{ $t('errors.go_home') }}
            </a>
        </div>
    </GuestLayout>
</template>

<script>
import GuestLayout from '@/Layouts/GuestLayout.vue';
import { Head } from '@inertiajs/vue3';

export default {
    props: {
        status: {
            type: Number,
            required: true
        }
    },
    computed: {
        title() {
            return {
                503: this.$t('errors.503.title'),
                500: this.$t('errors.500.title'),
                404: this.$t('errors.404.title'),
                403: this.$t('errors.403.title'),
            }[this.status];
        },
        description() {
            return {
                503: this.$t('errors.503.description'),
                500: this.$t('errors.500.description'),
                404: this.$t('errors.404.description'),
                403: this.$t('errors.403.description'),
            }[this.status];
        }
    },
    components: { GuestLayout, Head }
}
</script>